'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _ = require('../');

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _ModalAction = require('./ModalAction');

var _ModalAction2 = _interopRequireDefault(_ModalAction);

var _ModalFooter = require('./ModalFooter');

var _ModalFooter2 = _interopRequireDefault(_ModalFooter);

var _ModalWrapper = require('./ModalWrapper');

var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);

var _ModalClose = require('./ModalClose');

var _ModalClose2 = _interopRequireDefault(_ModalClose);

var _ModalHeader = require('./ModalHeader');

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _ModalTrigger = require('./ModalTrigger');

var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _focusTrapReact = require('focus-trap-react');

var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal() {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));

        _this.state = {
            open: _this.props.open || _this.props.defaultOpen || false
        };
        _this.id = _this.props.id || (0, _utils.idGen)('modal');
        _this.toggleModal = function (e) {
            var open = _this.props.open;

            if (open === undefined || open === null) {
                _this.setState(function (prevState) {
                    return {
                        open: !prevState.open
                    };
                });
            }
            _this.triggerEvents(e);
        };
        _this.handleSectionClick = function (e) {
            e.preventDefault();
            _this.toggleModal(e);
        };
        _this.handleContentClick = function (e) {
            e.stopPropagation();
        };
        _this.triggerEvents = function (e) {
            var _this$props = _this.props,
                onClose = _this$props.onClose,
                onOpen = _this$props.onOpen;
            var open = _this.state.open;

            if (onClose && open) {
                onClose(e);
            }
            if (onOpen && !open) {
                onOpen(e);
            }
        };
        _this.handleEscKey = function (e) {
            if (e.keyCode === 27 && _this.state.open) {
                _this.toggleModal(e);
            }
        };
        _this.componentWillReceiveProps = function (_ref) {
            var open = _ref.open;

            _this.setState({
                open: open
            });
        };
        _this.componentWillMount = function () {
            document.addEventListener('keydown', _this.handleEscKey, false);
        };
        _this.componentWillUnmount = function () {
            document.querySelector('body').classList.remove('has-activeModal');
            document.removeEventListener('keydown', _this.handleEscKey, false);
        };
        _this.render = function () {
            var _this$props2 = _this.props,
                propsChildren = _this$props2.children,
                className = _this$props2.className,
                title = _this$props2.title,
                _this$props2$headingI = _this$props2.headingId,
                headingId = _this$props2$headingI === undefined ? _this.id + '-heading' : _this$props2$headingI,
                _this$props2$contentI = _this$props2.contentId,
                contentId = _this$props2$contentI === undefined ? _this.id + '-content' : _this$props2$contentI,
                ariaLabelledBy = _this$props2.ariaLabelledBy,
                ariaDescribedBy = _this$props2.ariaDescribedBy,
                compact = _this$props2.compact,
                fullscreen = _this$props2.fullscreen,
                noContentWrapper = _this$props2.noContentWrapper,
                noActionsWrapper = _this$props2.noActionsWrapper,
                noFooterWrapper = _this$props2.noFooterWrapper,
                _this$props2$focusTra = _this$props2.focusTrap,
                focusTrap = _this$props2$focusTra === undefined ? true : _this$props2$focusTra;
            var open = _this.state.open;

            var children = _this.clearEmptyChildren(propsChildren);
            var trigger = _reactChildrenUtilities2.default.deepFind(children, function (child) {
                return child.type === _ModalTrigger2.default;
            });
            var actions = open && _this.extendWithCloseModalByComponentType(children, _ModalAction2.default);
            var modalFooters = open && _reactChildrenUtilities2.default.filter(children, function (child) {
                return child.type === _ModalFooter2.default;
            });
            var modalClose = open && _this.extendWithCloseModalByComponentType(children, _ModalClose2.default);
            var closeButton = modalClose && modalClose.length ? modalClose : _react2.default.createElement("button", { className: 'luna-modal__close', type: 'button', onClick: _this.toggleModal }, _react2.default.createElement(_.Icon, { name: 'close' }));
            var filteredChildren = _reactChildrenUtilities2.default.filter(children, function (child) {
                return child.type !== _ModalAction2.default && child.type !== _ModalFooter2.default && child.type !== _ModalHeader2.default && child.type !== _ModalTrigger2.default && child.type !== _ModalClose2.default;
            });
            var modalHeaders = open && _reactChildrenUtilities2.default.filter(children, function (child) {
                return child.type === _ModalHeader2.default;
            });
            var header = modalHeaders && modalHeaders.length > 0 ? _react2.default.cloneElement(modalHeaders[0], {
                headingId: headingId,
                title: title || modalHeaders[0].props.title,
                closeButton: closeButton
            }) : _react2.default.createElement(_ModalHeader2.default, { title: title, headingId: headingId, closeButton: closeButton });
            return _react2.default.createElement("div", null, trigger && _react2.default.cloneElement(trigger, {
                onClick: _this.toggleModal
            }), open && _react2.default.createElement(_focusTrapReact2.default, { active: focusTrap }, _react2.default.createElement("section", { className: (0, _classnames2.default)('luna-modal is-visible', className), "aria-hidden": 'false', role: 'dialog', id: _this.id, "aria-labelledby": ariaLabelledBy || headingId, "aria-describedby": ariaDescribedBy || contentId, tabIndex: '-1', onClick: _this.handleSectionClick }, _react2.default.createElement("div", { className: (0, _classnames2.default)('luna-modal__content', {
                    'luna-modal__content--compact': compact,
                    'luna-modal__content--fullscreen': fullscreen
                }), onClick: _this.handleContentClick }, title || modalHeaders.length ? header : closeButton, _react2.default.createElement("div", { className: 'luna-modal__body', id: contentId }, noContentWrapper ? filteredChildren : _react2.default.createElement(_ModalWrapper2.default, null, " ", filteredChildren, " ")), Boolean(actions.length) && _react2.default.createElement(_ModalFooter2.default, { toggleModal: _this.toggleModal, noActionsWrapper: noActionsWrapper, noFooterWrapper: noFooterWrapper }, actions), Boolean(modalFooters.length) && _react2.default.cloneElement(modalFooters[0], {
                actions: actions,
                noActionsWrapper: noActionsWrapper,
                noFooterWrapper: noFooterWrapper,
                toggleModal: _this.toggleModal
            })))));
        };
        return _this;
    }

    _createClass(Modal, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var open = this.state.open;

            (0, _utils.handleTagClassName)('body', 'has-activeModal', open);
        }
        // necessary, because of no support for empty components in case of 'deepMap' method

    }, {
        key: 'clearEmptyChildren',
        value: function clearEmptyChildren(children) {
            return _reactChildrenUtilities2.default.deepFilter(children, function (child) {
                return _react2.default.isValidElement(child) || typeof child === 'string';
            });
        }
    }, {
        key: 'extendWithCloseModalByComponentType',
        value: function extendWithCloseModalByComponentType(children, ModalComponent) {
            var _this2 = this;

            return _reactChildrenUtilities2.default.deepMap(children, function (child) {
                return child.type === ModalComponent ? _react2.default.cloneElement(child, {
                    closeModal: _this2.toggleModal
                }) : null;
            });
        }
    }]);

    return Modal;
}(_react2.default.Component);

Modal.propTypes = {
    onClose: _propTypes2.default.func,
    open: _propTypes2.default.bool,
    defaultOpen: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    id: _propTypes2.default.string,
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.node]),
    headingId: _propTypes2.default.string,
    contentId: _propTypes2.default.string,
    ariaLabelledBy: _propTypes2.default.string,
    ariaDescribedBy: _propTypes2.default.string,
    compact: _propTypes2.default.bool,
    fullscreen: _propTypes2.default.bool,
    noContentWrapper: _propTypes2.default.bool,
    noFooterWrapper: _propTypes2.default.bool,
    noActionsWrapper: _propTypes2.default.bool,
    onCloseButtonClick: _propTypes2.default.func,
    focusTrap: _propTypes2.default.bool
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/Modal.js